import script from "./Init.vue?vue&type=script&setup=true&lang=js"
export * from "./Init.vue?vue&type=script&setup=true&lang=js"

import "./Init.vue?vue&type=style&index=0&id=567423fe&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567423fe"]])

export default __exports__